<template>
  <v-container fluid
               v-if="contact">
    <page-title icon="fas fa-fw fa-fax">
      Edit Fax Contact
    </page-title>
    
    <v-form @submit.prevent="submit">
      <v-card>
        <v-card-text>
          <fax-contact-form :contact="contact"
                            :form="form">
          </fax-contact-form>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Update
          </v-btn>
          <v-btn @click.prevent="$router.back()">
            Cancel
          </v-btn>
          <v-btn v-if="contact.is_unsubscribed"
                 @click.prevent="resubscribe">
            Resubscribe
          </v-btn>
          <v-btn v-else
                 color="error"
                 @click.prevent="unsubscribe">
            Unsubscribe
          </v-btn>
          <template v-if="contact.messages.length === 0">
            <v-spacer></v-spacer>
            <v-btn color="error"
                   @click.prevent="deleteContact">
              Delete
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import faxService from '../../../services/faxService';
import FaxContactForm from '../library/components/FaxContactForm';
import {Form} from 'vform';
import DOMPurify from 'dompurify';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle, FaxContactForm},
  data() {
    return {
      busy: false,
      contact: null,
      form: new Form(faxService.getFormFields()),
    }
  },
  computed: {
    contactID() {
      return parseInt(this.$route.params.contactID);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      faxService.getContact(this.contactID)
        .then(data => {
          faxService.populateForm(this.form, data);
          this.contact = data;
        })
        .catch(err => {
          this.$toast.error('Contact not found');
          this.$router.replace({name: 'admin.fax_contacts.index'});
        })
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      faxService.updateContact(this.contactID, this.form)
        .then(data => {
          this.$router.push({name: 'admin.fax_contacts.index'});
        })
        .catch(err => {
          this.$toast.error(DOMPurify.sanitize(err.message));
        })
    },
    resubscribe() {
      if (confirm('Are you sure you want to resubscribe this contact?')) {
        faxService.resubscribeContact(this.contactID)
          .then(() => {
            this.$router.push({name: 'admin.fax_contacts.index'});
          })
          .catch(err => {
            this.$toast.error('There was a problem.');
          })
      }
    },
    unsubscribe() {
      if (confirm('Are you sure you want to unsubscribe this contact?')) {
        faxService.unsubscribeContact(this.contactID)
          .then(() => {
            this.$router.push({name: 'admin.fax_contacts.index'});
          })
          .catch(err => {
            this.$toast.error('There was a problem.');
          })
      }
    },
    deleteContact() {
      if (confirm('Are you sure you want to delete this contact?')) {
        faxService.deleteContact(this.contactID)
          .then(() => {
            setTimeout(() => {
              this.$router.replace({name: 'admin.fax_contacts.index'});
            }, 500);
          })
          .catch(err => {
            this.$toast.error('There was a problem.');
          })
      }
    }
  }
}
</script>
